var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-component-list"},_vm._l((_vm.items),function(item,index){return _c('div',{key:`${item.name}-${index}`,class:_vm.itemClasses(item)},[_c('div',{class:_vm.wrapperClass(item)},[_c(item.name,_vm._b({tag:"component",class:_vm.componentClass(item)},'component',item.props,false))],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }